import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { MessageContentItemOutput } from "~@/graphql/codegen/generated";

export enum ChatRoomPanel {
  Client = "client",
  Emoji = "emoji",
}

export interface ChatRoomState {
  messageText: string;
  messageContent: MessageContentItemOutput[];
  messagesSearch: string;
  panelMethod: ChatRoomPanel;
}

const initialState: ChatRoomState = {
  messageText: "",
  messageContent: [],
  messagesSearch: "",
  panelMethod: ChatRoomPanel.Client,
};

const chatRoomSlice = createSlice({
  name: "chatRoom",
  initialState,
  reducers: {
    setMessageText: (state, action: PayloadAction<string>) => {
      state.messageText = action.payload;
    },
    setMessageContent: (
      state,
      action: PayloadAction<MessageContentItemOutput[]>
    ) => {
      state.messageContent = action.payload;
    },
    // [AI_START::function id="appendMessageContent" purpose="Add one uploaded file without replacing the list, so FileItem does not re-run upload on every content change" links=["FilesUploadModal"]]
    appendMessageContent: (
      state,
      action: PayloadAction<MessageContentItemOutput>
    ) => {
      if (
        state.messageContent.some(
          (item) => item.fileName === action.payload.fileName
        )
      ) {
        return;
      }
      state.messageContent.push(action.payload);
    },
    // [AI_END::appendMessageContent]
    setMessagesSearch: (state, action: PayloadAction<string>) => {
      state.messagesSearch = action.payload;
    },
    setPanelMethod: (state, action: PayloadAction<ChatRoomPanel>) => {
      state.panelMethod = action.payload;
    },
    resetChatRoomState: () => initialState,
  },
});

export const {
  setMessageText,
  setMessageContent,
  appendMessageContent,
  setMessagesSearch,
  setPanelMethod,
  resetChatRoomState,
} = chatRoomSlice.actions;

export default chatRoomSlice.reducer;
